export const USER_SUBMIT_FORM = "USER_SUBMIT_FORM";
export const AUTO_SUBMIT_FORM = "AUTO_SUBMIT_FORM";
